import React from 'react'
import { useState, createElement } from "react";
import { graphql, Link } from 'gatsby'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import Img from 'gatsby-image'
import Layout from '../components/layout'
import { StoreButton } from '../components/store-button'
import ParallaxMousemove from 'react-parallax-mousemove'
import Slider from "react-slick";
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import specialFormatter from '../utility/special-formatter'
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

class BlogPostTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      curLang: "en"
    };
  }


  youtubeId(url) {
    const regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    return (match&&match[1].length==11)? match[1] : false;
  }

  render() {
    const faqs = get(this, 'props.data.allContentfulFaqEntry.edges')
    if (faqs !== undefined)
    { 
      const faqMaps = new Map();
      const faqTitleMaps = new Map();
      const faqHTMLMaps = new Map();
      const faqProcessedHTMLMaps = new Map();
      const headersMap = new Map();
      const langMaps = new Map();
      const langs = []
      const langButtons = [];
      let backLink = "";

      faqs.map(({ node }, index) => {
        faqMaps.set(node.language.shortcode, node.faqBody.childContentfulRichText.html )
        faqTitleMaps.set(node.language.shortcode, node.faqTitle )
        langMaps.set(node.language.shortcode, { DisplayName : node.language.displayName, Order: node.language.order })
      })

      langMaps.forEach((langObject, shortcode, map ) => {
        langs.push( 
        {
          DisplayName : langObject.DisplayName,
          ShortCode : shortcode,
          Order : langObject.Order,
        })
      })
      langs.sort((a,b) => { return a.Order > b.Order ? 1 : -1 })
      langs.forEach((language) => {
        faqHTMLMaps.set( language.ShortCode, [])
        ReactHtmlParser(specialFormatter(faqMaps.get(language.ShortCode), true),
        {
          transform: ( node, index ) => 
            { 
              if(node.name === 'h2' )
              { 
                    let recursiveNodeSearch = 
                    ( node ) =>
                    {
                      if( node.type === 'text' )
                      {
                          if( node.data.trim().length > 0 )
                          {
                            if( !headersMap.has(language.ShortCode) )
                            {
                              headersMap.set(language.ShortCode, [] )
                              faqProcessedHTMLMaps.set(language.ShortCode, [] )
                            }
                            headersMap.get(language.ShortCode).push(node.data);
                          }
                      }
                      else
                      {
                        node.children.forEach(recursiveNodeSearch);
                      }
                    };                
                node.children.forEach( recursiveNodeSearch );

                node.attribs.id = 'header' + (headersMap.get(language.ShortCode).length-1);
                  
                faqHTMLMaps.get(language.ShortCode).push(convertNodeToElement( node, index ));
              }
              else if (!node.parent )
              {
                faqHTMLMaps.get(language.ShortCode).push(convertNodeToElement( node, index ));
              }
            } 
        })
        langButtons.push({
              shortcode: language.ShortCode,
              value: 
              (<button onClick={() => 
                this.setState
                  ({
                    curLang: language.ShortCode
                  })
              }>{language.DisplayName} </button>)
          })
        })
      langs.forEach((language) => {
        let startCollating = false;
        let collapsedHTML = [];
        faqHTMLMaps.get(language.ShortCode).forEach((entry)=>
        {
          if(entry.type === 'h2' )
          {
            if(startCollating)
            {
              faqProcessedHTMLMaps.get(language.ShortCode).push( createElement( 'div', { className:'faq-entry'}, collapsedHTML ));
              collapsedHTML = [];
            } 
            else
            {
              startCollating = true;
            }
            faqProcessedHTMLMaps.get(language.ShortCode).push( entry );
          } 
          else
          {
            if(!startCollating)
            {
              faqProcessedHTMLMaps.get(language.ShortCode).push( entry );
            }
            else
            {
              collapsedHTML.push( entry );  
            }
          }
        })

        faqProcessedHTMLMaps.get(language.ShortCode).push( createElement( 'div', { className:'faq-entry'}, collapsedHTML ));
      })
      return (
        <Layout location={this.props.location} >
          <link href='https://fonts.googleapis.com/css?family=Noto Sans' rel='stylesheet'></link>
          { langButtons.length > 1 ?
          <div className="language-selector">
          {langButtons.map(langButton => {
            if (this.state.curLang == langButton.shortcode) return <div style={{display: 'inline-block'}} className="selected-language">{langButton.value}</div>;
            return langButton.value;
          })}
          </div> : <div></div>
          }
          <div className="faq">
          <h1 className="faq-title">{faqTitleMaps.get(this.state.curLang)}</h1>
          <ul className="faq-toc">
            {headersMap.has(this.state.curLang) ? (headersMap.get(this.state.curLang).map((header, index) => { return (<li><a href={`#header${index}`}><h3>{header}</h3></a></li>)})) : <div>No Headers</div> }
          </ul>
          {
              faqProcessedHTMLMaps.get(this.state.curLang)
          }
          </div>
        </Layout>
      )
    } else {
      return (<div> No FAQs for this game yet! </div>)
    }
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query FaqsByGameName($gameName: String!) {
    allContentfulFaqEntry(filter: {game: {name:{ eq: $gameName }}} ) 
    {
      edges 
      {
        node 
        {
          language
          {
            name
            displayName
            shortcode
            order
          }
          game 
          {
            id
            name
            slug
          }
          faqID
          faqTitle
          faqBody  {
            childContentfulRichText {
              html
            }
          }
        }
      }
    }
  }
`
